<div class="h-100  single-report-page">
    <app-admin-report [columns]="idleCustomersReport" [hasFilters]="true" [apiUrl]="reportAPI"
                      [rowDataUrl]="IdleCustomerRawDataUrl"
                      [isIdleCustomerReport]="true"
                      reportTitle="ADMINISTRATION.IDLE_CUSTOMER_REPORT_TITLE">
        <ng-template>
        </ng-template>
    </app-admin-report>
</div>
